import { IconButton } from '@nexelem/components';
import { styled, Theme } from '@nexelem/deprecated-theme';
import { ProLightGear } from '@nexelem/icons/ProLightGear';

const CustomIcon = styled(IconButton)(({ theme }) => {
  const typedTheme = theme as Theme;
  const { getColor, hexToRGB } = typedTheme.palette;
  const { filters } = typedTheme.client.filters;
  return {
    width: typedTheme.spacing(10),
    height: typedTheme.spacing(10),
    ':focus': {
      backgroundColor: hexToRGB(getColor(filters.activeFilterIcon), 0.9),
    },
  };
});

interface SettingsIconProps {
  handleOnClickSettings: () => void;
  countSettings: number;
  totalNumberOfSettings: number;
}

export const SettingsIcon = ({ handleOnClickSettings, countSettings, totalNumberOfSettings }: SettingsIconProps) => (
  <CustomIcon
    count={countSettings > 0 ? `${countSettings} / ${totalNumberOfSettings}` : undefined}
    Icon={ProLightGear}
    withIndicator={countSettings > 0}
    onClick={handleOnClickSettings}
  />
);
